import create from 'zustand';

interface IUseTablePreSelectedRows {
  selectedRows: number[];
  updatePreSelectedRows(args: number[]): void;
}

export const useTeamsTableSelectedRows = create<IUseTablePreSelectedRows>((set) => ({
  selectedRows: [],
  updatePreSelectedRows: (selectedRows: number[]) => set({ selectedRows: selectedRows }),
}));

export const useAssignedTeamsTableSelectedRows = create<IUseTablePreSelectedRows>((set) => ({
  selectedRows: [],
  updatePreSelectedRows: (selectedRows: number[]) => set({ selectedRows: selectedRows }),
}));

export const useRecruitersTableSelectedRows = create<IUseTablePreSelectedRows>((set) => ({
  selectedRows: [],
  updatePreSelectedRows: (selectedRows: number[]) => set({ selectedRows: selectedRows }),
}));

export const useAssignedRecruitersTableSelectedRows = create<IUseTablePreSelectedRows>((set) => ({
  selectedRows: [],
  updatePreSelectedRows: (selectedRows: number[]) => set({ selectedRows: selectedRows }),
}));
